module.exports = __webpack_public_path__ + "static/img/ikona_cw4-ON.d880aa41.png";